import axios from 'axios';

const api = axios.create({
    baseURL: 'https://financeforum2026.colab208.com.br/api'
});

export default api;
